import { useState, useCallback } from 'react';

export const useCustomDialog = () => {
  const [open, setOpen] = useState(false);
  const handleClose = useCallback(() => setOpen(false), [setOpen]);
  const handleOpen = useCallback(() => setOpen(true), [setOpen]);

  return { open, handleClose, handleOpen, setOpen };
};
